import React from 'react';

export const DynamicInstaIcon = ({ className, ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      className={className}
    >
      <g filter="url(#filter0_d_6160_6712)">
        <rect
          x="4.5"
          y="0.498047"
          width="54"
          height="54"
          rx="27"
          fill="white"
          fillOpacity="0.3"
          shapeRendering="crispEdges"
        />
        <rect
          x="5"
          y="0.998047"
          width="53"
          height="53"
          rx="26.5"
          stroke="#AB9005"
          shapeRendering="crispEdges"
        />
        <circle cx="31.5" cy="27.498" r="17" fill="var(--color-primary)" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.3842 22.6939C37.3842 23.2904 36.9006 23.7739 36.3042 23.7739C35.7078 23.7739 35.2242 23.2904 35.2242 22.6939C35.2242 22.0973 35.7078 21.6139 36.3042 21.6139C36.9007 21.6139 37.3842 22.0973 37.3842 22.6939ZM31.5 30.498C29.8432 30.498 28.5 29.1549 28.5 27.498C28.5 25.8412 29.8432 24.4981 31.5 24.4981C33.1568 24.4981 34.5 25.8412 34.5 27.498C34.5 29.1549 33.1568 30.498 31.5 30.498ZM31.5 22.8764C28.9475 22.8764 26.8784 24.9456 26.8784 27.498C26.8784 30.0505 28.9475 32.1197 31.5 32.1197C34.0525 32.1197 36.1216 30.0505 36.1216 27.498C36.1216 24.9456 34.0525 22.8764 31.5 22.8764ZM31.5 20.1197C33.9031 20.1197 34.1878 20.1289 35.1367 20.1722C36.0142 20.2123 36.4908 20.3588 36.8079 20.4821C37.2279 20.6454 37.5277 20.8404 37.8427 21.1554C38.1577 21.4703 38.3528 21.7701 38.5161 22.1903C38.6392 22.5074 38.7859 22.984 38.826 23.8615C38.8693 24.8106 38.8785 25.0952 38.8785 27.4983C38.8785 29.9015 38.8693 30.1861 38.826 31.135C38.7859 32.0125 38.6394 32.4891 38.5161 32.8062C38.3528 33.2263 38.1577 33.5261 37.8427 33.8411C37.5279 34.1561 37.2281 34.3511 36.8079 34.5144C36.4908 34.6376 36.0142 34.7843 35.1367 34.8243C34.1878 34.8676 33.9031 34.8768 31.5 34.8768C29.0967 34.8768 28.8121 34.8676 27.8632 34.8243C26.9857 34.7843 26.5091 34.6377 26.192 34.5144C25.7719 34.3511 25.4721 34.1561 25.1571 33.8411C24.8423 33.5262 24.6471 33.2264 24.4838 32.8062C24.3606 32.4891 24.2139 32.0125 24.1739 31.135C24.1305 30.186 24.1214 29.9013 24.1214 27.4983C24.1214 25.0952 24.1305 24.8106 24.1739 23.8615C24.2139 22.984 24.3605 22.5074 24.4838 22.1903C24.6471 21.7703 24.8421 21.4704 25.1571 21.1554C25.472 20.8404 25.7718 20.6454 26.192 20.4821C26.5091 20.3589 26.9857 20.2123 27.8632 20.1722C28.8122 20.1289 29.0969 20.1197 31.5 20.1197ZM31.5 18.498C29.0558 18.498 28.7492 18.5085 27.7893 18.5522C26.8314 18.5959 26.1771 18.7481 25.6047 18.9705C25.0128 19.2005 24.5109 19.5083 24.0106 20.0086C23.5102 20.509 23.2024 21.0109 22.9725 21.6028C22.75 22.1752 22.5979 22.8294 22.5541 23.7874C22.5104 24.7473 22.5 25.0538 22.5 27.498C22.5 29.9423 22.5104 30.2488 22.5541 31.2087C22.5979 32.1667 22.75 32.8208 22.9725 33.3933C23.2024 33.9852 23.5102 34.4871 24.0106 34.9875C24.5109 35.4878 25.0128 35.7955 25.6047 36.0255C26.1772 36.248 26.8314 36.4002 27.7893 36.4439C28.7492 36.4876 29.0558 36.498 31.5 36.498C33.9442 36.498 34.2508 36.4876 35.2107 36.4439C36.1686 36.4002 36.8228 36.248 37.3953 36.0255C37.9872 35.7955 38.4891 35.4878 38.9894 34.9875C39.4897 34.4871 39.7974 33.9852 40.0275 33.3933C40.25 32.8208 40.4021 32.1667 40.4459 31.2087C40.4896 30.2488 40.5 29.9423 40.5 27.498C40.5 25.0538 40.4896 24.7473 40.4459 23.7874C40.4021 22.8294 40.25 22.1752 40.0275 21.6028C39.7974 21.0109 39.4897 20.509 38.9894 20.0086C38.4891 19.5083 37.9872 19.2006 37.3953 18.9705C36.8228 18.7481 36.1686 18.5959 35.2107 18.5522C34.2508 18.5085 33.9442 18.498 31.5 18.498Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6160_6712"
          x="0.5"
          y="0.498047"
          width="62"
          height="62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6160_6712"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6160_6712"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
